module.exports = __webpack_public_path__ + "static/media/4@3x.7413145f.png";